var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddonToProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4061 3.73549C17.7673 3.896 18 4.25412 18 4.64931V13.411C18 13.7742 17.8031 14.1088 17.4856 14.2852L9.48564 18.7296C9.18362 18.8974 8.81638 18.8974 8.51436 18.7296L0.514357 14.2852C0.196892 14.1088 0 13.7742 0 13.411V4.64931C0 4.25412 0.232734 3.896 0.593862 3.73549L8.59386 0.179938C8.85243 0.0650205 9.14757 0.0650205 9.40614 0.179938L17.4061 3.73549Z",
    fill: "#506EFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9668 1.22266L4.59961 5.31552V9.90392L6.59961 10.9039V6.49233L14.2547 2.23951L11.9668 1.22266Z",
    fill: "#506EFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddonToProduct);
export default __webpack_public_path__ + "static/media/addonToProduct.00406a7ec8dc966983f90d153b23f927.svg";
export { ForwardRef as ReactComponent };